import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogActions, DialogContentText
} from '@material-ui/core';
import { Button } from "react-admin";

type ConfirmDialogProps = {
  label: string;
  title?: string;
  content?: string;
  onConfirm: () => Promise<void> | void;
  okText?: string;
  cancelText?: string;
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  label,
  content = 'Confirm this operation',
  onConfirm,
  okText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(true);

  const handleCancel = () => setOpen(false);

  const handleOk = async () => {
    try {
      await onConfirm();
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        label={label} onClick={handleClick} style={{ color: 'red' }}
      />
      <Dialog open={open} onClose={handleCancel}>
        <DialogContent>
          <DialogContentText>
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="default" label={cancelText} />
          <Button onClick={handleOk} color="secondary" label={okText} />
        </DialogActions>
      </Dialog>
    </>
  );
};
